export const blockIconsAudioandvideoPlayPauseNew = (
	<span className='material-symbols-outlined'>play_pause</span>
);
